import { ComponentRef, Injectable, Type, ViewContainerRef } from '@angular/core';
import { DmpHlFindPatientParams } from 'src/app/utils/interfaces/new/dmp-hl-find-patient-params.interface';
import { DmpHlFindPatientResponse,
  DmpHlFindPatientResponseSIns } from 'src/app/utils/interfaces/new/dmp-hl-find-patient-response.interface';
import { DmpHlGetCertifiedIdentityParams } from 'src/app/utils/interfaces/new/dmp-hl-get-certified-identity-params.interface';
import { DmpHlGetCertifiedIdentityResponse } from 'src/app/utils/interfaces/new/dmp-hl-get-certified-identity-response.interface';
import { DmpHlGetDirectAuthentificationDmpStatus, DmpStatusEnum, DmpUserAuthorizationEnum } from 'src/app/utils/interfaces/new/dmp-hl-get-direct-authentification-dmp-status.interface';
import { DmpHlGetInteropCodesEnum } from 'src/app/utils/enums/dmp-hl-get-interop-codes-params.enum';
import { DmpHlGetInteropCodesResponse } from 'src/app/utils/interfaces/new/dmp-hl-get-interop-codes-response.interface';
import { DmpHlGetWebPsUrlsResponse } from 'src/app/utils/interfaces/new/dmp-hl-get-web-ps-urls-response.interface';
import { DmpHlUpdateUserAccessAuthorizationParams } from 'src/app/utils/interfaces/new/dmp-hl-update-user-access-authorization-identity-params.interface';
import { DmpParameters, DmpServiceAbstract, HistoriqueVaccination, HistoriqueVaccinationImmunizations, HistoriqueVaccinationImmunizationsAuthor, HistoriqueVaccinationStructuredBodySections, UpdateNoteVaccinationId, VaccinationConsumable, VaccinationVaccinator, VaccinatorAddress, VaccinatorTelecom, VaccinAValider, ValidationVaccination } from '../dmp-service.abstract';
import { DmpHlFindDocumentsParams } from 'src/app/utils/interfaces/new/dmp-hl-find-documents-params.interface';
import { DmpAuthor, DmpHlFindDocumentsResponse } from 'src/app/utils/interfaces/new/dmp-hl-find-documents-response.interface';
import { DmpHlGetDocumentContentParams } from 'src/app/utils/interfaces/new/dmp-hl-get-document-content-params.interface';
import { DmpHlGetDocumentContentResponse } from 'src/app/utils/interfaces/new/dmp-hl-get-document-content-response.interface';
import { DmpHlDeleteDocumentParams } from 'src/app/utils/interfaces/new/dmp-hl-delete-document-params.interface';
import { DmpHlsendDocumentsParams, DmpHlsendDocumentsDocument } from 'src/app/utils/interfaces/new/dmp-hl-send-documents-params.interface';
import { DmpHlAccessModeEnum, DmpHlSetDmpAccessModeParams } from 'src/app/utils/interfaces/new/dmp-hl-set-dmp-access-mode-params.interface';
import { DoRetryError } from '../../cpx-handle/cpx-handle.service';
import { CpxHandleServiceAbstract, SessionTypeEnum, TypeConnecteurEnum } from '../../cpx-handle/cpx-handle-service-abstract';
import { environment } from 'src/environments/environment';
import { CpxCardStatusEnum, CpxSessionInterface, CpxTypeEnum } from 'src/app/utils/interfaces/new/cpx-session.interface';
import moment from 'moment';
import { DmpVisibilityEnum } from 'src/app/utils/enums/dmp-visibility.enum';
import { RessourceService } from '../../ressource/ressource.service';
import { StringUtilsService } from '../../string-utils/string-utils.service';
import { ReferentielService } from '../../referentiel/referentiel.service';
import { DmpFormatEnum } from 'src/app/utils/enums/dmp-format.enum';
import { v4 } from 'uuid';
import { DmpVaccin } from '../../vaccin/vaccin.service';
import { UnauthorizedCpeCardError } from '../../cpx-handle/cpx-handle.error';
import { DmpHlArchiveDocumentParams } from 'src/app/utils/interfaces/new/dmp-hl-archive-document-params.interface';
import { DmpGetMyDocumentsParams } from 'src/app/utils/interfaces/new/dmp-get-my-documents-params.interface';
import { DmpGetMyDocumentsResult } from 'src/app/utils/interfaces/new/dmp-get-my-documents-result.interface';
import { DmpHlVisibilityDocumentParams } from 'src/app/utils/interfaces/new/dmp-hl-visibility-document-params.interface';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { DmpAddMyDocumentsParams } from 'src/app/utils/interfaces/new/dmp-add-my-documents-params.interface';
import { FichePatient } from 'src/app/utils/interfaces/new/fiche-patient.interface';
import { PatientService } from '../../patient/patient.service';
import { ModalService } from '../../modal/modal.service';
import { FormTemplate } from 'src/app/utils/interfaces/new/form-template.interfac';
import { LoadingModalFragment } from 'src/app/fragments/modal/loading/loading-modal.fragment';
import { AddEditFragment } from 'src/app/fragments/modal/add-edit/add-edit.fragment';
import { ReferentielEnum } from 'src/app/utils/enums/referentiel-enum';
import { DmpGetLastAccessDateParams } from 'src/app/utils/interfaces/new/dmp-get-last-access-date-params.interface';
import { ActionEnum, DomainEnum, LogFonctionnelCallerService, LogFonctionnelService, LogObject, ResultEnum, TypeTargetEnum } from '../../log-fonctionnel/log-fonctionnel.service';
import { buildSendDocErrorLog, buildSendDocSuccessLog } from './dmp-log.utils';

export const practiceSettingKey = 'dmp_params_practice_setting';
export const mailizAccountKey = 'mailiz_account';
export const identifiantNationalKey = 'identifiant-national';
export const professionSettingKey = 'dmp_params_profession_setting';
export const specialiteSettingKey = 'dmp_params_specialite_setting';
export const nomSettingKey = 'dmp_params_nom_setting';
export const prenomSettingKey = 'dmp_params_prenom_setting';
export const numeroAMFinessKey = 'dmp_params_numeroamfiness_setting';
export const idnatStructureSettingKey = 'dmp_params_idnatstruct_setting';
export const nomStructureSettingKey = 'dmp_params_nomstruct_setting';
export const typeStructureSettingKey = 'dmp_params_typestruct_setting';
export const contentTypeCodeSettingKey = 'dmp_params_content_type_code_setting';
export const envoiAutomatiqueSettingKey = 'dmp_params_envoi_automatique_setting';

const DOCUMENT_PATH = '/medical/documents-dmp';
const DMP_LAST_ACCESS_PATH = '/medical/dernier-acces-dmp';

export interface NgSelectValue {
  id: string;
  libelle: string;
}

export const InternalIdTypes: Array<NgSelectValue> = [
  { id: '3', libelle: "Numéro RPPS" },
  { id: '4', libelle: "Numéro ADELI" },
  { id: '5', libelle: "Numéro SIRIUS" },
  { id: '6', libelle: "Numéro étudiant" },
  { id: '7', libelle: "Numéro interne d'une structure ADELI" },
  { id: '8', libelle: "Numéro interne d'une structure FINESS" },
  { id: '9', libelle: "Numéro interne d'une structure SIREN" },
  { id: '10', libelle: "Numéro interne d'une structure SIRET" },
  { id: '11', libelle: "Numéro interne RPPS" },
  { id: '12', libelle: "Numéro interne (autre)" },
];

export interface UserInfos {
  name: string;
  given: string;
  profession: string;
  professionOid: string;
  speciality: string;
  internalId: string;
  internalIdType: string;
  // tel?: string;
  // numAddress?: string;
  // streetType?: string;
  // street?: string;
  // zip?: string;
  // city?: string;
  institution: {
    practiceLocationBillingNumber: string;
    practiceLocationName: string;
    practiceSettingValue: string;
    // tel?: string;
    // numAddress?: string;
    // streetType?: string;
    // street?: string;
    // zip?: string;
    // city?: string;
  }
}

export interface UserInfosDmp {
  hpName: string;
  hpGiven: string;
  hpProfession: string;
  hpProfessionOid: string;
  hpSpecialty?: string;
  hpInternalId: string;
  hpInternalIdType?: string;
  Institution: UserInfosInstitutionDmp;
}

export interface UserInfosInstitutionDmp {
  s_id: string;
  s_name: string;
  s_classCode: string;
  Addresses?: Array<VaccinatorAddress>;
  Telecoms?: Array<VaccinatorTelecom>;
}

interface TypeDocumentDMP {
  id: string,
  libelle: string,
  meta: {
    s_code: string,
    s_displayName: string
    s_codeSystem: string,
  }
}

export const ProfessionsAllowingSepcialities = [
  '10', // physicians
  '21', // pharmacists
  '40', // dentists
];
@Injectable({
  providedIn: 'root'
})
export class DmpWebSocketStrategyService extends DmpServiceAbstract {

  public resourceId: string;

  private _cpxInstance: any;

  private modeEP = false;
  private base64Cert: string;

  private typeSession: SessionTypeEnum = SessionTypeEnum.CARTE;

  private basePath = environment.basePath + DOCUMENT_PATH;
  private lastAccessBasePath = environment.basePath + DMP_LAST_ACCESS_PATH;

  public documentVisibilite = Object.keys(DmpVisibilityEnum).map((v) => {
    if (isNaN(Number(v))) {
      return {
        id: DmpVisibilityEnum[v],
        libelle: v,
        disabled: false
      }
    }
  }).filter((v) => v !== undefined);

  public dmpTypeDocument: TypeDocumentDMP[] = [];

  private _logCallSrv: LogFonctionnelCallerService;

  constructor(
    private _cpxHandleSrv: CpxHandleServiceAbstract,
    private _resourceSrv: RessourceService,
    private _strUtilsSrv: StringUtilsService,
    private _refSrv: ReferentielService,
    private _patientSrv: PatientService,
    private _http: HttpClient,
    private _modal: ModalService,
    private _ref: ReferentielService,
    private _logSrv: LogFonctionnelService,
  ) {
    super();
    this.initListTypeDocument();

    _cpxHandleSrv.cpxCardRipped.subscribe(() => {
    });
  }

  public async hl_getdirectauthentificationdmpstatus(view: ViewContainerRef, patientIns: string): Promise<DmpHlGetDirectAuthentificationDmpStatus> {
    return new Promise<DmpHlGetDirectAuthentificationDmpStatus>(async (resolve, reject) => {
      try {
        if (!await this._createConnector(view)) {
          resolve(undefined);
          return;
        }
      } catch (e) {
        if (e instanceof DoRetryError) {
          resolve(await this.hl_getdirectauthentificationdmpstatus(view, patientIns));
          return;
        } else if (e.message && typeof e.message === 'string') {
          reject({ message: e.message });
        } else {
          reject({ message: 'Une erreur est survenue' });
        }
        return;
      }

      try {
        resolve(await this._getDmpStatut(view, patientIns));
      } catch (e) {
        reject(e);
      }
    });
  }

  private _getDmpStatutTryCount = 0;
  private async _getDmpStatut(view: ViewContainerRef, patientIns: string): Promise<DmpHlGetDirectAuthentificationDmpStatus> {
    const _getDMPStatutIndirect = async (cpxInstance: any, ins: string): Promise<DmpHlGetDirectAuthentificationDmpStatus> => {
      return new Promise<DmpHlGetDirectAuthentificationDmpStatus>((resolve, reject) => {
        try {
          var command = {
              "s_commandName"               : "hl_getDMPStatus",
              "s_ins"                       : ins,
              "s_sessionId"                 : cpxInstance.getSessionId()
          };
          return cpxInstance.sendCommand( command, 20, (result) => {
            console.log(result);
          } );
        } catch (e) {
          reject(e);
        }
      });
    };

    if (patientIns === '255069999999934T') {
      patientIns = '255069999999934D';
    }

    return new Promise<DmpHlGetDirectAuthentificationDmpStatus>(async (resolve, reject) => {
      try {
        if (await this._cpxHandleSrv.isESConnexionIndirect(SessionTypeEnum.CERT_DMP)) {
          resolve(await _getDMPStatutIndirect(this._cpxInstance, patientIns));
        } else {
          this._cpxInstance.hl_getDirectAuthenticationDMPStatus(patientIns, async (res) => {
            if (this._cpxHandleSrv.isErrorEndSession(res, SessionTypeEnum.CARTE)) {
              resolve(await _getDMPStatutIndirect(this._cpxInstance, patientIns));
            } else if (res.error && res.error.s_status === 'ERROR' && res.error.i_apiErrorCode === 2 && res.error.i_apiErrorType === 6000
              && (res.error.s_apiErrorExtendedInformations as string).includes('The DMP connector is not initialized')) {
              await this._createConnector(view);
              resolve(this.hl_getdirectauthentificationdmpstatus(view, patientIns));
            } else if (res.error && res.error.s_status === 'ERROR' && res.error.i_apiErrorCode === 59 && res.error.i_apiErrorType === 2 && this._getDmpStatutTryCount < 2) {
              resolve(this.hl_getdirectauthentificationdmpstatus(view, patientIns));
              this._getDmpStatutTryCount++;
            } else if (res.error || res.s_status === 'ERROR') {
              const keys = Object.keys(res.error || res);
              const msgArr: Array<string> = [];
              for (const k of keys) {
                msgArr.push(`${k} : ${res.error[k]}`);
              }
              this._getDmpStatutTryCount = 0;
              reject({ message: msgArr.join('\n') });
            } else {
              res.i_treatingPhysician = Boolean(res.i_treatingPhysician);
              res.ExistingTestAnswer.i_webAccessIsOpen = Boolean(res.ExistingTestAnswer.i_webAccessIsOpen);
              res.ExistingTestAnswer.i_ensRelatedDmp = Boolean(res.ExistingTestAnswer.i_ensRelatedDmp);
              res.ExistingTestAnswer.s_closingDate = moment(res.ExistingTestAnswer.s_closingDate, 'YYYYMMDD').toDate();
              res.ExistingTestAnswer.AdminData.s_birthday = moment(res.ExistingTestAnswer.AdminData.s_birthday, 'YYYYMMDD').toDate();
              this._getDmpStatutTryCount = 0;
              resolve(res);
            }
          });
        }
      } catch (e) {
        reject(e);
      }
    });
  }

  public async hl_updateuserdmpaccessauthorization(view: ViewContainerRef, authorizationParams: DmpHlUpdateUserAccessAuthorizationParams): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      try {
        if (!await this._createConnector(view)) {
          resolve(undefined);
          return;
        }
      } catch (e) {
        if (e instanceof DoRetryError) {
          resolve(await this.hl_updateuserdmpaccessauthorization(view, authorizationParams));
          return;
        } else {
          reject({ message: 'Une erreur est survenue' });
        }
        return;
      }

      try {
        const ins = `${authorizationParams.s_ins.s_ins}${authorizationParams.s_ins.s_ins !== '255069999999934' ? environment.dmpInsSuffix : 'D'}`;

        const status = await this.hl_getdirectauthentificationdmpstatus(view, ins);
        authorizationParams.i_setTreatingPhysician = status.i_treatingPhysician;

        this._cpxInstance.hl_updateUserDmpAccessAuthorization(
          ins,
          authorizationParams.i_action,
          authorizationParams.i_setTreatingPhysician,
          null,
          async (res) => {
            if (this._cpxHandleSrv.isErrorEndSession(res, SessionTypeEnum.CARTE)) {
              resolve(await this.hl_updateuserdmpaccessauthorization(view, authorizationParams));
            } else if (res.error || res.s_status === 'ERROR') {
              const keys = Object.keys(res.error || res);
              const msgArr: Array<string> = [];
              for (const k of keys) {
                msgArr.push(`${k} : ${res.error[k]}`);
              }
              reject({ message: msgArr.join('\n') });
          } else {
            resolve(res);
          }
        });
      } catch (e) {
        reject(e);
      }
    });
  }

  public async hl_setdmpaccessmode(view: ViewContainerRef, accessMode: DmpHlSetDmpAccessModeParams): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      try {
        if (!await this._createConnector(view)) {
          resolve(undefined);
          return;
        }
      } catch (e) {
        if (e instanceof DoRetryError) {
          resolve(await this.hl_setdmpaccessmode(view, accessMode));
          return;
        } else {
          reject({ message: 'Une erreur est survenue' });
        }
        return;
      }

      try {
        this._cpxInstance.hl_setDmpAccessMode(
          accessMode.i_accessMode,
          accessMode.i_accessMode === DmpHlAccessModeEnum['Accès normal'] ? '' : accessMode.s_reason,
          null,
          async (res) => {
            if (this._cpxHandleSrv.isErrorEndSession(res, SessionTypeEnum.CARTE)) {
              resolve(await this.hl_setdmpaccessmode(view, accessMode));
            } else if (res.error || res.s_status === 'ERROR') {
              const keys = Object.keys(res.error || res);
              const msgArr: Array<string> = [];
              for (const k of keys) {
                msgArr.push(`${k} : ${res.error[k]}`);
              }
              reject({ message: msgArr.join('\n') });
          } else {
            resolve(res);
            this._accessMode = accessMode.i_accessMode;
          }
        });
      } catch (e) {
        reject(e);
      }
    });
  }

  private _accessMode: DmpHlAccessModeEnum = undefined;
  public get accessMode(): DmpHlAccessModeEnum {
    return this._accessMode;
  }
  public set accessMode(accessMode: DmpHlAccessModeEnum) {
    this._accessMode = accessMode;
  }

  private async _setWebPsRootUrl(instance: any): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      if (environment.isHomologation) {
        this._cpxInstance.hl_setWebPsRootUrl(
          `${environment.homologationWebPsRootUrl}`,
          async (res) => {
            resolve(res);
        });
      } else {
        resolve();
      }
    });
  }

  public async hl_getwebpsdmpurls(view: ViewContainerRef, sIns: DmpHlFindPatientResponseSIns): Promise<DmpHlGetWebPsUrlsResponse> {
    return new Promise<DmpHlGetWebPsUrlsResponse>(async (resolve, reject) => {
      try {
        if (!await this._createConnector(view)) {
          resolve(undefined);
          return;
        }
      } catch (e) {
        if (e instanceof DoRetryError) {
          resolve(await this.hl_getwebpsdmpurls(view, sIns));
          return;
        } else {
          reject({ message: 'Une erreur est survenue' });
        }
        return;
      }

      try {
        // On set l'URL root du Web PS
        await this._setWebPsRootUrl(this._cpxInstance);

        this._cpxInstance.hl_getWebPsDmpUrls(
          `${sIns.s_ins}${sIns.s_ins !== '255069999999934' ? environment.dmpInsSuffix : 'D'}`,undefined,
          async (res) => {
            if (this._cpxHandleSrv.isErrorEndSession(res, SessionTypeEnum.CARTE)) {
              resolve(await this.hl_getwebpsdmpurls(view, sIns));
            } else if (res.error || res.s_status === 'ERROR') {
              const keys = Object.keys(res.error || res);
              const msgArr: Array<string> = [];
              for (const k of keys) {
                msgArr.push(`${k} : ${res.error[k]}`);
              }
              reject({ message: msgArr.join('\n') });
          } else {
            resolve(res);
          }
        });
      } catch (e) {
        reject(e);
      }
    });
  }

  public async hl_getInteropCodes(view: ViewContainerRef, sCodeIds: DmpHlGetInteropCodesEnum[]): Promise<DmpHlGetInteropCodesResponse> {
    return new Promise<DmpHlGetInteropCodesResponse>(async (resolve, reject) => {
      try {
        if (!await this._createConnector(view)) {
          resolve(undefined);
          return;
        }
      } catch (e) {
        if (e instanceof DoRetryError) {
          resolve(await this.hl_getInteropCodes(view, sCodeIds));
          return;
        } else {
          reject({ message: 'Une erreur est survenue' });
        }
        return;
      }

      try {
        this._cpxInstance.hl_getInteropCodes({ s_codeIds : sCodeIds }, async (res) => {
          if (this._cpxHandleSrv.isErrorEndSession(res, SessionTypeEnum.CARTE)) {
            resolve(await this.hl_getInteropCodes(view, sCodeIds));
          } else if (res.error || res.s_status === 'ERROR') {
            const keys = Object.keys(res.error || res);
            const msgArr: Array<string> = [];
            for (const k of keys) {
              msgArr.push(`${k} : ${res.error[k]}`);
            }
            reject({ message: msgArr.join('\n') });
          } else {
            resolve(res);
          }
        });
      } catch (e) {
        reject(e);
      }
    });
  }

  public async hl_finddocuments(view: ViewContainerRef, ins: DmpHlFindPatientResponseSIns,
                                searchParams: DmpHlFindDocumentsParams): Promise<Array<DmpHlFindDocumentsResponse>> {
    let mapCategories = undefined;
    if (searchParams.Categories) {
      mapCategories = {};
      let i = 0;
      searchParams.Categories.forEach((v: string, k: string) => {
        mapCategories[`#${i}`] = k;
        i++;
      });
    }

    let mapFormats = undefined;
    if (searchParams.Formats) {
      mapFormats = {};
      let i = 0;
      for (const f of searchParams.Formats) {
        mapFormats[`#${i}`] = f[0];
        i++;
      }
    }

    return new Promise<Array<DmpHlFindDocumentsResponse>>(async (resolve, reject) => {
      try {
        if (!await this._createConnector(view)) {
          resolve(undefined);
          return;
        }
      } catch (e) {
        if (e instanceof DoRetryError) {
          resolve(await this.hl_finddocuments(view, ins, searchParams));
          return;
        } else {
          reject({ message: 'Une erreur est survenue' });
        }
        return;
      }

      try {
        const session = await this._cpxHandleSrv.getCpxSession(view, await this._getSessionType(view));
        if (session.cpxType === CpxTypeEnum.CPE) {
          reject(new UnauthorizedCpeCardError('L\'accès aux documents du DMP d\'un patient n\'est pas autorisé lors d\'une authentification par carte CPE'))
          return;
        }
      } catch (e) {
        reject(e);
        return;
      }

      try {
        const searchParamsTmp = {...searchParams};
        searchParamsTmp.Categories = mapCategories;
        searchParamsTmp.Formats = mapFormats;

        this._cpxInstance.hl_findDocuments(
          `${ins.s_ins}${ins.s_ins !== '255069999999934' ? environment.dmpInsSuffix : 'D'}`,
          searchParamsTmp,
          async (res) => {
            if (this._cpxHandleSrv.isErrorEndSession(res, SessionTypeEnum.CARTE)) {
              resolve(await this.hl_finddocuments(view, ins, searchParams));
            } else if (res.error || res.s_status === 'ERROR') {
              const keys = Object.keys(res.error || res);
              const msgArr: Array<string> = [];
              for (const k of keys) {
                msgArr.push(`${k} : ${res.error[k]}`);
              }
              reject({ message: msgArr.join('\n') });
            } else {
              const rtd: Array<DmpHlFindDocumentsResponse> = [];
              for (const d of res.Documents) {
                d.s_creationDate = d.s_creationDate && moment(d.s_creationDate, 'YYYYMMDDHHmmss').isValid() ?
                  moment(d.s_creationDate, 'YYYYMMDDHHmmss').toDate() : undefined;
                d.s_serviceStartDate = d.s_serviceStartDate && moment(d.s_serviceStartDate, 'YYYYMMDDHHmmss').isValid() ?
                  moment(d.s_serviceStartDate, 'YYYYMMDDHHmmss').toDate() : undefined;
                d.s_serviceStopDate = d.s_serviceStopDate && moment(d.s_serviceStopDate, 'YYYYMMDDHHmmss').isValid() ?
                  moment(d.s_serviceStopDate, 'YYYYMMDDHHmmss').toDate() : undefined;
                d.s_submissionDate = d.s_submissionDate && moment(d.s_submissionDate, 'YYYYMMDDHHmmss').isValid() ?
                  moment(d.s_submissionDate, 'YYYYMMDDHHmmss').toDate() : undefined;
                rtd.push(d);
              }

              resolve(rtd);
            }
          }
        );
      } catch (e) {
        reject(e);
      }
    });
  }

  public async hl_getdocumentcontent(view: ViewContainerRef, downloadParams: DmpHlGetDocumentContentParams): Promise<DmpHlGetDocumentContentResponse> {
    return new Promise<DmpHlGetDocumentContentResponse>(async (resolve, reject) => {
      try {
        if (!await this._createConnector(view)) {
          resolve(undefined);
          return;
        }
      } catch (e) {
        if (e instanceof DoRetryError) {
          resolve(await this.hl_getdocumentcontent(view, downloadParams));
          return;
        } else {
          reject({ message: 'Une erreur est survenue' });
        }
        return;
      }

      try {
        const session = await this._cpxHandleSrv.getCpxSession(view, await this._getSessionType(view));
        if (session.cpxType === CpxTypeEnum.CPE) {
          reject(new UnauthorizedCpeCardError('L\'accès aux documents du DMP d\'un patient n\'est pas autorisé lors d\'une authentification par carte CPE'))
          return;
        }
      } catch (e) {
        reject(e);
        return;
      }

      try {
        this._cpxInstance.hl_getDocumentContentByUniqueId(
          `${downloadParams.ins.s_ins}${downloadParams.ins.s_ins !== '255069999999934' ? environment.dmpInsSuffix : 'D'}`,
          downloadParams.uniqueId,
          downloadParams.uuid,
          null,
          async (res) => {
            if (this._cpxHandleSrv.isErrorEndSession(res, SessionTypeEnum.CARTE)) {
              resolve(await this.hl_getdocumentcontent(view, downloadParams));
            } else if (res.error || res.s_status === 'ERROR') {
              const keys = Object.keys(res.error || res);
              const msgArr: Array<string> = [];
              for (const k of keys) {
                msgArr.push(`${k} : ${res.error[k]}`);
              }
              reject({ message: msgArr.join('\n') });
            } else {
              resolve(res);
            }
          }
        );
      } catch (e) {
        reject(e);
      }
    });
  }

  public async hl_deletedocument(view: ViewContainerRef, deleteParams: DmpHlDeleteDocumentParams, patientId?: string): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      try {
        if (!await this._createConnector(view)) {
          resolve(undefined);
          return;
        }
      } catch (e) {
        if (e instanceof DoRetryError) {
          resolve(await this.hl_deletedocument(view, deleteParams));
          return;
        } else {
          reject({ message: 'Une erreur est survenue' });
        }
        return;
      }

      try {
        this._cpxInstance.hl_deleteDocument(
          deleteParams.s_uniqueId,
          `${deleteParams.s_ins.s_ins}${deleteParams.s_ins.s_ins !== '255069999999934' ? environment.dmpInsSuffix : 'D'}`,
          deleteParams.s_healthcareSettings,
          {
            s_uuid: deleteParams.s_uuid
          },
          async (res) => {
            if (this._cpxHandleSrv.isErrorEndSession(res, SessionTypeEnum.CARTE)) {
              resolve(await this.hl_deletedocument(view, deleteParams, patientId));
            } else if (res.error || res.s_status === 'ERROR') {
              const keys = Object.keys(res.error || res);
              const msgArr: Array<string> = [];
              for (const k of keys) {
                msgArr.push(`${k} : ${res.error[k]}`);
              }

              this._addLog({
                action: ActionEnum.Delete,
                result: ResultEnum.Error,
                typeTarget: TypeTargetEnum.Patient,
                idTarget: patientId,
                subDomain: 'Suppression document DMP',
                internals: { error: res.error, deleteParams },
                details: `Échec de la suppression du document DMP ${deleteParams.s_title ? ': ' + deleteParams.s_title : deleteParams.s_uniqueId}`
              });

              reject({ message: msgArr.join('\n') });
            } else {
              await this.deleteFromMyDocuments(deleteParams.s_uniqueId);

              this._addLog({
                action: ActionEnum.Delete,
                result: ResultEnum.Success,
                typeTarget: TypeTargetEnum.Patient,
                idTarget: patientId,
                subDomain: 'Suppression document DMP',
                internals: { deleteParams },
                details: `Succès de la suppression du document DMP ${deleteParams.s_title ? ': ' + deleteParams.s_title : deleteParams.s_uniqueId}`
              });

              resolve(res);
            }
          }
        );
      } catch (e) {
        this._addLog({
          action: ActionEnum.Delete,
          result: ResultEnum.Error,
          typeTarget: TypeTargetEnum.Patient,
          idTarget: patientId,
          subDomain: 'Suppression document DMP',
          internals: { error: e.message, deleteParams },
          details: `Échec de la suppression du document DMP ${deleteParams.s_title ? ': ' + deleteParams.s_title : deleteParams.s_uniqueId}`
        });
        reject(e);
      }
    });
  }

  public async getMyDocuments(myDocsParams: DmpGetMyDocumentsParams): Promise<Array<DmpGetMyDocumentsResult>> {
    return new Promise<Array<DmpGetMyDocumentsResult>>(async (resolve, reject) => {
      try {
        let httpParams = new HttpParams();
        httpParams = httpParams.append('patientIns', myDocsParams.patientIns);
        httpParams = httpParams.append('rpps', encodeURIComponent(myDocsParams.rpps));

        const res = await this._http.get<Array<DmpGetMyDocumentsResult>>(`${this.basePath}`, { params: httpParams }).toPromise();
        resolve(res);
      } catch (e) {
        reject(e);
      }
    });
  }

  public async deleteFromMyDocuments(uniqueId: string): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      try {
        await this._http.delete<void>(`${this.basePath}/${uniqueId}`).toPromise();
        resolve();
      } catch (e) {
        reject(e);
      }
    });
  }

  public async addMyDocuments(myDocsParams: DmpAddMyDocumentsParams, uniqueId?: string): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      try {
        if (uniqueId) {
          await this._http.put<Array<DmpGetMyDocumentsResult>>(`${this.basePath}/${uniqueId}`, myDocsParams).toPromise();
        } else {
          await this._http.post<Array<DmpGetMyDocumentsResult>>(`${this.basePath}`, myDocsParams).toPromise();
        }
        resolve();
      } catch (e) {
        reject(e);
      }
    })
  }

  public async updateMyDocumentsDocumentId(uniqueId: string, documentId: string): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      try {
        await this._http.put<Array<DmpGetMyDocumentsResult>>(`${this.basePath}/${uniqueId}/documentId`, { documentId }).toPromise();
        resolve();
      } catch (e) {
        reject(e);
      }
    })
  }

  public async searchDMPDocumentByDocumentId(list:Array<string>) : Promise<Array<{documentDmp:DmpGetMyDocumentsResult, documentId:string}>> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
    const res = await this._http.post<Array<{documentDmp:DmpGetMyDocumentsResult, documentId:string}>>(`${this.basePath}/documentId/search`, JSON.stringify(list), {headers: headers}).toPromise();
    return res
  }

  public async getLastAccessDate(lastAccessParams: DmpGetLastAccessDateParams): Promise<Date | undefined> {
    return new Promise<Date | undefined>(async (resolve, reject) => {
      try {
        if (lastAccessParams.patientIns && lastAccessParams.rpps) {
          const date = await this._http.get<string>(`${this.lastAccessBasePath}/${lastAccessParams.patientIns}/${lastAccessParams.rpps}`).toPromise();
          resolve(date ? moment(date).toDate() : undefined);
        } else {
          resolve(undefined);
        }
      } catch (e) {
        reject(e);
      }
    })
  }

  public async setLastAccessDate(lastAccessParams: DmpGetLastAccessDateParams): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      try {
        if (lastAccessParams.patientIns && lastAccessParams.rpps) {
          await this._http.put(`${this.lastAccessBasePath}/${lastAccessParams.patientIns}/${lastAccessParams.rpps}`, undefined).toPromise();
          resolve();
        } else {
          resolve();
        }
      } catch (e) {
        reject(e);
      }
    })
  }

  /**
   * Archive ou désarchive un document
   * - si archivé, devient désarchivé
   * - si non archivé, devient archivé
   */
  public async archiveDocumentByUniqueId(view: ViewContainerRef, archiveParams: DmpHlArchiveDocumentParams): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      try {
        if (!await this._createConnector(view)) {
          resolve(undefined);
          return;
        }
      } catch (e) {
        if (e instanceof DoRetryError) {
          resolve(await this.archiveDocumentByUniqueId(view, archiveParams));
          return;
        } else {
          reject({ message: 'Une erreur est survenue' });
        }
        return;
      }

      // let docUuid: string | undefined = undefined;
      // try {
      //   docUuid = await this.hl_getDocumentUuidByUniqueId(view, archiveParams);
      // } catch (e) {
      //   reject(e);
      // }

      // if (!docUuid) {
      //   reject({ message: 'Impossible de trouver l\'identifiant du document.' });
      //   return;
      // }

      try {
        this._cpxInstance.hl_updateDocumentStatusByUniqueId(
          `${archiveParams.s_ins.s_ins}${archiveParams.s_ins.s_insType}`,
          archiveParams.s_documentUniqueId,
          archiveParams.s_documentUuid,
          archiveParams.s_healthcareSettings,
          undefined,
          async (res) => {
            if (this._cpxHandleSrv.isErrorEndSession(res, SessionTypeEnum.CARTE)) {
              resolve(await this.archiveDocumentByUniqueId(view, archiveParams));
            } else if (res.error || res.s_status === 'ERROR') {
              const keys = Object.keys(res.error || res);
              const msgArr: Array<string> = [];
              for (const k of keys) {
                msgArr.push(`${k} : ${res.error[k]}`);
              }
              reject({ message: msgArr.join('\n') });
            } else {
              resolve(res);
            }
          }
        );
      } catch (e) {
        reject(e);
      }
    });
  }
  public async updateVisibilityDocumentByUniqueId(view: ViewContainerRef, archiveParams: DmpHlVisibilityDocumentParams): Promise<any> {
    return new Promise<any>(async (resolve, reject) => {
      try {
        if (!await this._createConnector(view)) {
          resolve(undefined);
          return;
        }
      } catch (e) {
        if (e instanceof DoRetryError) {
          resolve(await this.updateVisibilityDocumentByUniqueId(view, archiveParams));
          return;
        } else {
          reject({ message: 'Une erreur est survenue' });
        }
        return;
      }

      try {
        this._cpxInstance.hl_updateDocumentVisibilityByUniqueId(
          `${archiveParams.s_ins.s_ins}${archiveParams.s_ins.s_insType}`,
          archiveParams.s_documentUniqueId,
          archiveParams.s_documentUuid,
          archiveParams.s_healthCareSettings,
          archiveParams.i_document_Visibility,
          undefined,
          async (res) => {
            if (this._cpxHandleSrv.isErrorEndSession(res, SessionTypeEnum.CARTE)) {
              resolve(await this.updateVisibilityDocumentByUniqueId(view, archiveParams));
            } else if (res.error || res.s_status === 'ERROR') {
              const keys = Object.keys(res.error || res);
              const msgArr: Array<string> = [];
              for (const k of keys) {
                msgArr.push(`${k} : ${res.error[k]}`);
              }
              reject({ message: msgArr.join('\n') });
            } else {
              resolve(res);
            }
          }
        );
      } catch (e) {
        reject(e);
      }
    });
  }

  public async hl_getDocumentUuidByUniqueId(view: ViewContainerRef, documentInfos: { s_documentUniqueId: string, s_ins: DmpHlFindPatientResponseSIns }): Promise<string> {
    return new Promise<string>(async (resolve, reject) => {
      try {
        if (!await this._createConnector(view)) {
          resolve(undefined);
          return;
        }
      } catch (e) {
        if (e instanceof DoRetryError) {
          resolve(await this.hl_getDocumentUuidByUniqueId(view, documentInfos));
          return;
        } else {
          reject({ message: 'Une erreur est survenue' });
        }
        return;
      }

      try {
        this._cpxInstance.hl_getDocumentUuidByUniqueId(
          documentInfos.s_documentUniqueId,
          `${documentInfos.s_ins.s_ins}${documentInfos.s_ins.s_ins !== '255069999999934' ? environment.dmpInsSuffix : 'D'}`,
          undefined,
          async (res) => {
            if (this._cpxHandleSrv.isErrorEndSession(res, SessionTypeEnum.CARTE)) {
              resolve(await this.hl_getDocumentUuidByUniqueId(view, documentInfos));
            } else if (res.error || res.s_status === 'ERROR') {
              const keys = Object.keys(res.error || res);
              const msgArr: Array<string> = [];
              for (const k of keys) {
                msgArr.push(`${k} : ${res.error[k]}`);
              }
              reject({ message: msgArr.join('\n') });
            } else {
              resolve(res.s_documentUuid);
            }
          }
        );
      } catch (e) {
        reject(e);
      }
    });
  }

  private async _getPracticeLocationActivity(): Promise<{pinCode?: string, practiceLocationActivity: string, practiceSettingIndice?: number} | undefined> {
    return await this._cpxHandleSrv.getPracticeLocationActivity();
  }

  private async _getCpxSession(view: ViewContainerRef): Promise<any> {
    return await this._cpxHandleSrv.getCpxSession(view, await this._getSessionType(view));
  }

  public async hl_deleteArchivedDocument(view: ViewContainerRef, deleteParams: DmpHlDeleteDocumentParams, patientId?: string): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      try {
        if (!await this._createConnector(view)) {
          resolve(undefined);
          return;
        }
      } catch (e) {
        if (e instanceof DoRetryError) {
          resolve(await this.hl_deleteArchivedDocument(view, deleteParams));
          return;
        } else {
          reject({ message: 'Une erreur est survenue' });
        }
        return;
      }

      try {
        this._cpxInstance.hl_deleteArchivedDocument(
          deleteParams.s_uniqueId,
          `${deleteParams.s_ins.s_ins}${deleteParams.s_ins.s_ins !== '255069999999934' ? environment.dmpInsSuffix : 'D'}`,
          deleteParams.s_healthcareSettings,
          {
            s_uuid: deleteParams.s_uuid
          },
          async (res) => {
            if (this._cpxHandleSrv.isErrorEndSession(res, SessionTypeEnum.CARTE)) {
              resolve(await this.hl_deleteArchivedDocument(view, deleteParams, patientId));
            } else if (res.error || res.s_status === 'ERROR') {
              const keys = Object.keys(res.error || res);
              const msgArr: Array<string> = [];
              for (const k of keys) {
                msgArr.push(`${k} : ${res.error[k]}`);
              }

              this._addLog({
                action: ActionEnum.Delete,
                result: ResultEnum.Error,
                typeTarget: TypeTargetEnum.Patient,
                idTarget: patientId,
                subDomain: 'Suppression archive DMP',
                internals: { error: res.error, deleteParams },
                details: `Échec de la suppression de l'archive DMP ${deleteParams.s_title ? ': ' + deleteParams.s_title : deleteParams.s_uniqueId}`
              });

              reject({ message: msgArr.join('\n') });
            } else {

              this._addLog({
                action: ActionEnum.Delete,
                result: ResultEnum.Success,
                typeTarget: TypeTargetEnum.Patient,
                idTarget: patientId,
                subDomain: 'Suppression archive DMP',
                internals: { deleteParams },
                details: `Succès de la suppression de l'archive DMP ${deleteParams.s_title ? ': ' + deleteParams.s_title : deleteParams.s_uniqueId}`
              });

              resolve(res);
            }
          }
        );
      } catch (e) {
        this._addLog({
          action: ActionEnum.Delete,
          result: ResultEnum.Error,
          typeTarget: TypeTargetEnum.Patient,
          idTarget: patientId,
          subDomain: 'Suppression archive DMP',
          internals: { error: e.message, deleteParams },
          details: `Échec de la suppression de l'archive DMP ${deleteParams.s_title ? ': ' + deleteParams.s_title : deleteParams.s_uniqueId}`
        });
        reject(e);
      }
    });
  }

  private async _getSessionType(view: ViewContainerRef): Promise<SessionTypeEnum> {
    const isEs = await this._cpxHandleSrv.isESConnexionIndirect(SessionTypeEnum.CERT_DMP);
    return isEs ? SessionTypeEnum.CERT_DMP : SessionTypeEnum.CARTE;
  }

  public async getCisCodes(view: ViewContainerRef, search?: string): Promise<Array<{ id: string, libelle: string }>> {
    return new Promise<Array<{ id: string, libelle: string }>>(async (resolve, reject) => {
      try {
        const session = await this._cpxHandleSrv.getCpxSession(view, await this._getSessionType(view));
        if (!session) {
          resolve(undefined);
          return;
        }

        this._cpxInstance.sendCommand(
          {
            s_commandName: 'hl_getCisCodes',
            s_sessionId: this._cpxInstance.getSessionId(),
            s_name: search && search !== '' ? search : undefined
          },
          60,
          async (res) => {
            if (this._cpxHandleSrv.isErrorEndSession(res, SessionTypeEnum.CARTE)) {
              resolve(await this.getCisCodes(view, search));
            } else if (!res || res.error || (res.s_status && res.s_status !== 'OK')) {
              reject(res);
            } else {
              resolve(res.Codes.map(c => {
                return { id: c.s_code, libelle: c.s_name, atcCodes: c.s_atcCode, ucdCodes: c.UcdCodes};
              }));
            }
          },
          false
        );
      } catch (e) {
        reject(e);
      }
    });
  }

  //cette méthode ne fonctionne pas avec search = "nom du vaccin", il faut probablement lui passer le type de vaccin pour qu'elle retourne le code ATC
  public async getAtcCodes(view: ViewContainerRef, search?: string): Promise<Array<{ id: string, libelle: string }>> {
    return new Promise<Array<{ id: string, libelle: string }>>(async (resolve, reject) => {
      try {
        const session = await this._cpxHandleSrv.getCpxSession(view, await this._getSessionType(view));
        if (!session) {
          resolve(undefined);
          return;
        }

        this._cpxInstance.sendCommand(
          {
            s_commandName: 'hl_getAtcCodes',
            s_sessionId: this._cpxInstance.getSessionId(),
            s_nameFr: search && search !== '' ? search : undefined
          },
          60,
          async (res) => {
            if (this._cpxHandleSrv.isErrorEndSession(res, SessionTypeEnum.CARTE)) {
              resolve(await this.getAtcCodes(view, search));
            } else if (!res || res.error || (res.s_status && res.s_status !== 'OK')) {
              reject(res);
            } else {
              resolve(res.Codes.map(c => {
                return { id: c.s_code, libelle: c.Names.s_fr && c.Names.s_fr !== '' ? c.Names.s_fr : c.Names.s_en };
              }));
            }
          },
          false
        );
      } catch (e) {
        reject(e);
      }
    });
  }

  public async rechercherHistoriqueDeVaccination(view: ViewContainerRef, ins: DmpHlFindPatientResponseSIns): Promise<HistoriqueVaccination>{
    return new Promise<HistoriqueVaccination>(async (resolve, reject) => {
      try {
        if (!await this._createConnector(view)) {
          resolve(undefined);
          return;
        }
      } catch (e) {
        if (e instanceof DoRetryError) {
          resolve(await this.rechercherHistoriqueDeVaccination(view, ins));
          return;
        } else {
          reject({ message: 'Une erreur est survenue' });
        }
        return;
      }

      try {
        const session = await this._cpxHandleSrv.getCpxSession(view, await this._getSessionType(view));
        if (session.cpxType === CpxTypeEnum.CPE) {
          reject(new UnauthorizedCpeCardError('L\'accès aux documents du DMP d\'un patient n\'est pas autorisé lors d\'une authentification par carte CPE'))
          return;
        }
      } catch (e) {
        reject(e);
        return;
      }

      try {
        const mapTmp = new Map<string, string>();
        mapTmp.set('11369-6', '');

        const result = await this.hl_finddocuments(
          view,
          ins, {
            Categories: mapTmp,
            Formats: undefined,
            i_status: 1,
            i_visibility: undefined,
            Practices: undefined,
            s_creationDateBottom: undefined,
            s_creationDateTop: undefined,
            s_ins: ins,
            s_serviceStartDateBottom: undefined,
            s_serviceStartDateTop: undefined,
            s_serviceStopDateTop: undefined,
            s_serviceStopDateBottom: undefined,
            s_submissionDateBottom: undefined,
            s_submissionDateTop: undefined
          }
        );

        if (result && result.length === 1) {
          const vaccsHisto = await this.hl_getdocumentcontent(view, { ins, uniqueId: result[0].s_uniqueId, uuid: result[0].s_uuid });

          this._cpxInstance.hl_getDocumentFromCda(
            vaccsHisto.s_cdaContentInBase64,
            async (res) => {
              if (this._cpxHandleSrv.isErrorEndSession(res, SessionTypeEnum.CARTE)) {
                resolve(await this.rechercherHistoriqueDeVaccination(view, ins));
              } else if (res.error || res.s_status === 'ERROR') {
                const keys = Object.keys(res.error || res);
                const msgArr: Array<string> = [];
                for (const k of keys) {
                  msgArr.push(`${k} : ${res.error[k]}`);
                }
                reject({ message: msgArr.join('\n') });
              } else {
                resolve(res);
              }
            }
          );
          // resolve({...vaccsHisto as unknown as HistoriqueVaccination} as HistoriqueVaccination);
        } else {
          resolve(undefined);
        }
      } catch (e) {
        reject(e);
      }
    });
  }

  public async getVaccinationContent(view: ViewContainerRef, documentHandle: number): Promise<any> {
    return new Promise<Array<VaccinAValider>>(async (resolve, reject) => {
      try {
        if (!await this._createConnector(view)) {
          resolve(undefined);
          return;
        }
      } catch (e) {
        if (e instanceof DoRetryError) {
          resolve(await this.getVaccinationContent(view, documentHandle));
          return;
        } else {
          reject({ message: 'Une erreur est survenue' });
        }
        return;
      }

      try {
        const session = await this._cpxHandleSrv.getCpxSession(view, await this._getSessionType(view));
        if (session.cpxType === CpxTypeEnum.CPE) {
          reject(new UnauthorizedCpeCardError('L\'accès aux documents du DMP d\'un patient n\'est pas autorisé lors d\'une authentification par carte CPE'))
          return;
        }
      } catch (e) {
        reject(e);
        return;
      }

      try {

        this._cpxInstance.hl_getDocumentContent(
          documentHandle,
          null,
          async (res) => {
            if (this._cpxHandleSrv.isErrorEndSession(res, SessionTypeEnum.CARTE)) {
              resolve(await this.getVaccinationContent(view, documentHandle));
            } else if (res.error || res.s_status === 'ERROR') {
              const keys = Object.keys(res.error || res);
              const msgArr: Array<string> = [];
              for (const k of keys) {
                msgArr.push(`${k} : ${res.error[k]}`);
              }
              reject({ message: msgArr.join('\n') });
            } else {
              resolve(res);
            }
          }
        );

        resolve(undefined);
      } catch (e) {
        reject(e);
      }
    });
  }


  public async rechercherVaccinAValider(view: ViewContainerRef, ins: DmpHlFindPatientResponseSIns): Promise<Array<VaccinAValider>> {
    return new Promise<Array<VaccinAValider>>(async (resolve, reject) => {
      try {
        if (!await this._createConnector(view)) {
          resolve(undefined);
          return;
        }
      } catch (e) {
        if (e instanceof DoRetryError) {
          resolve(await this.rechercherVaccinAValider(view, ins));
          return;
        } else {
          reject({ message: 'Une erreur est survenue' });
        }
        return;
      }

      try {
        const rtd: Array<VaccinAValider> = [];
        const vaccsHisto = await this.rechercherHistoriqueDeVaccination(view, ins);
        if (vaccsHisto && vaccsHisto.Authors && vaccsHisto.Authors.length > 0
          && vaccsHisto.Authors.find(a => a.s_hpProfession === 'EXP_PATIENT')
          && vaccsHisto.StructuredBody?.Sections?.length > 0) {
          const patientIns = vaccsHisto.Authors.find(a => a.s_hpProfession === 'EXP_PATIENT').s_hpInternalId;
          if (patientIns && patientIns === ins.s_ins) {
            const immunizations = vaccsHisto.StructuredBody.Sections[0].Immunizations as Array<HistoriqueVaccinationImmunizations>;
            for (const immunization of immunizations) {
              if (immunization.Author?.s_hpInternalId === patientIns) {
                rtd.push({
                  date: immunization.s_date,
                  cis: immunization.Consumable.s_cisCode,
                  consumable: {
                    name: immunization.Consumable.s_name,
                    lotNumber: immunization.Consumable.s_lotNumber,
                    cisCode: immunization.Consumable.s_cisCode,
                    cisCodeDescription: immunization.Consumable.s_cisCodeDescription,
                    cipCode: immunization.Consumable.s_cipCode,
                    cipCodeDescription: immunization.Consumable.s_cipCodeDescription,
                    atcCode: immunization.Consumable.s_atcCode,
                    atcCodeDescription: immunization.Consumable.s_atcCodeDescription,
                    ucdCode: immunization.Consumable.s_ucdCode,
                    ucdCodeDescription: immunization.Consumable.s_ucdCodeDescription,
                    mvCode: immunization.Consumable.s_mvCode,
                    mvCodeDescription: immunization.Consumable.s_mvCodeDescription,
                  },
                  vaccinator: immunization.Performer?.s_hpName || 'Inconnu',
                  meta: immunization
                });
              }
            }
          }
        }

        resolve(rtd);
      } catch (e) {
        reject(e);
      }
    });
  }

  // tslint:disable-next-line: max-line-length
  public async ajouterNoteDeVaccin(view: ViewContainerRef, sendingParam: DmpHlsendDocumentsParams, consumable: VaccinationConsumable, author: VaccinationVaccinator, vaccinator: VaccinationVaccinator, dateInjection: Date, vaccinId?: UpdateNoteVaccinationId, patientId?: string): Promise<DmpVaccin> {
    return new Promise<DmpVaccin>(async (resolve, reject) => {

      try {
        if (!await this._createConnector(view)) {
          resolve(undefined);
          return;
        }
      } catch (e) {
        if (e instanceof DoRetryError) {
          resolve(await this.ajouterNoteDeVaccin(view, sendingParam, consumable, author, vaccinator, dateInjection, vaccinId, patientId));
          return;
        } else {
          this._logSendDocError(e, { s_title: 'Note de vaccination' }, patientId);
          reject({ message: 'Une erreur est survenue' });
        }
        return;
      }

      try {
        const session = await this._cpxHandleSrv.getCpxSession(view, await this._getSessionType(view));
        if (!session) {
          resolve(undefined);
          return;
        }

        const authorParsed = this._getVaccinAuthor(author);
        const performer = this._getVaccinAuthor(vaccinator);

        const consumableData = {
          s_name: consumable.name,
          s_lotNumber: consumable.lotNumber,
          s_cisCode: consumable.cisCode,
          s_cisCodeDescription: consumable.cisCodeDescription,
          s_cipCode: consumable.cipCode || undefined,
          s_cipCodeDescription: consumable.cipCodeDescription || undefined,
          s_atcCode: consumable.atcCode,
          s_atcCodeDescription: consumable.atcCodeDescription,
          s_ucdCode: consumable.ucdCode || undefined,
          s_ucdCodeDescription: consumable.ucdCodeDescription || undefined,
          s_mvCode: consumable.mvCode || undefined,
          s_mvCodeDescription: consumable.mvCodeDescription || undefined,
        };

        const vaccinEntryId = (vaccinId?.vaccinEntryId || v4() as string).toUpperCase();

        const structuredBody = {
          Sections: [{
            i_type: 30,   // Type de section pour "Note de vaccination" (Voir doc)
            s_title: 'Note de vaccination',   // Section pour "Note de vaccination" (Voir doc)
            Immunizations: [{
              Author: authorParsed,
              Performer: performer,
              Consumable: consumableData,
              i_type: consumable.type ? Number(consumable.type) : undefined,   // Donnée facultative
              i_immunizationRoute: consumable.route ? Number(consumable.route) : undefined,    // Donnée facultative
              i_approachSite: consumable.approachSite ? Number(consumable.approachSite) : undefined,   // Donnée facultative
              i_rank: consumable.rank ? Number(consumable.rank) : undefined,    // Donnée facultative
              i_doseQuantity: consumable.doseQty ? Number(consumable.doseQty) : undefined,    // Donnée facultative
              s_date: moment(dateInjection).format('YYYYMMDD'),
              s_entryId: vaccinEntryId,
              Comment: consumable.comment ? { s_text: consumable.comment } : undefined    // Donnée facultative
            }]
          }]
        };

        let visibility = DmpVisibilityEnum['Le document est visible de tous'];
        // Bonjour,
        // le GIE nous confirme que l'ajout d'une note de vaccination ne peut se faire en connexion secrète (lié à l'exigence EX_2.1-2005). La demande à été remontée à la CNAM pour préciser ce point dans la spécification. Nous avons demandé également à ce que le serveur retourne une erreur plus cohérente vis à vis de ce point.
        // Cordialement,
        // Romuald Perrot.
        //
        // if (!!session.confidentialityLevel) {
        //   visibility = DmpVisibilityEnum['Le document n\'est pas visible par le représentant légal du patient'];
        // }
        const documentMeta = {
          s_title: 'Note de vaccination',
          documentId: undefined,
          s_uniqueId: undefined,
          s_category: '87273-9',
          s_classCode: 'Note de Vaccination',
          i_format: 'urn:asip:ci-sis:vac-note:2021',
          s_description: 'Note de Vaccination',
          i_visibility: visibility,
          authors: { auteur: authorParsed, vaccinateur: performer },
          dateCreation: structuredBody.Sections[0].Immunizations[0].s_date,
          vaccinInformation: structuredBody,
        }

        this._cpxInstance.hl_sendDocument(
          `${sendingParam.s_ins.s_ins}${sendingParam.s_ins.s_ins !== '255069999999934' ? environment.dmpInsSuffix : 'D'}`,
          sendingParam.s_birthPlaceCode,
          undefined,
          'Note de vaccination',
          undefined,
          '87273-9',    // Type "Note de Vaccination"
          visibility,
          'urn:asip:ci-sis:vac-note:2021',      // FormatCode "Note de Vaccination"
          session.PracticeLocations[session.practiceSettingIndice].s_practiceLocationActivity,
          vaccinId?.vaccinUniqueId || undefined,
          sendingParam.s_submissionSetTitle ? sendingParam.s_submissionSetTitle : '',
          sendingParam.s_submissionSetDescription ? sendingParam.s_submissionSetDescription : '',
          undefined,
          { StructuredBody: structuredBody, // ICI StructuedBody de la vaccination
            i_retrieveDocumentUuid: 1, },
          async (res) => {
            if (this._cpxHandleSrv.isErrorEndSession(res, SessionTypeEnum.CARTE)) {
              this._logSendDocError(res, structuredBody, patientId);
              resolve(await this.ajouterNoteDeVaccin(view, sendingParam, consumable, author, vaccinator, dateInjection, vaccinId, patientId));
            } else if (res.error || res.s_status === 'ERROR') {
              const keys = Object.keys(res.error || res);
              const msgArr: Array<string> = [];
              for (const k of keys) {
                msgArr.push(`${k} : ${res.error[k]}`);
              }
              this._logSendDocError(res, documentMeta, patientId);
              reject({ message: msgArr.join('\n') });
            } else {
              this._logSendDocSuccess(res, documentMeta, patientId);
              if (res.s_uniqueId) {
                const session:CpxSessionInterface = await this._cpxHandleSrv.getCpxSession(view, SessionTypeEnum.CARTE);
                const obj:DmpAddMyDocumentsParams = {
                  uuid: '',
                  uniqueId: res.s_uniqueId,
                  patientIns: sendingParam.s_ins.s_ins,
                  rpps: session.dmpConnectSessionInfos.s_internalId,
                  title: 'Note de vaccination',
                  formatCode: 'urn:asip:ci-sis:vac-note:2021',
                  category: '87273-9',
                  visibility: visibility,
                  createdWithSecretmode: !!session.confidentialityLevel,
                }

                if (consumable.comment) {
                  obj.comment = consumable.comment
                }

                await this.addMyDocuments(obj);
              }
              resolve({
                entryId: vaccinEntryId,
                uniqueId: res.s_uniqueId
              });
            }
          }
        );
      } catch (e) {
        reject(e);
      }
    });
  }

  public async deleteNoteDeVaccination(view: ViewContainerRef, deleteParams: DmpHlDeleteDocumentParams): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {

      try {
        if (!await this._createConnector(view)) {
          resolve(undefined);
          return;
        }
      } catch (e) {
        if (e instanceof DoRetryError) {
          resolve(await this.deleteNoteDeVaccination(view, deleteParams));
          return;
        } else {
          reject({ message: 'Une erreur est survenue' });
        }
        return;
      }

      try {
        const session = await this._cpxHandleSrv.getCpxSession(view, await this._getSessionType(view));
        if (!session) {
          resolve(undefined);
          return;
        }

        resolve(await this.hl_deleteArchivedDocument(view, deleteParams));
      } catch (e) {
        reject(e);
      }
    });
  }

  private  _getVaccinAuthor(author: VaccinationVaccinator): any | undefined {

    // const _getConvertTelecom = (telecom: VaccinatorTelecom): any => {
    //   return {
    //     i_type: telecom.type,
    //     i_usage: telecom.usage || undefined,
    //     s_value: telecom.value,
    //   };
    // };

    // const _getConvertAddress = (address: VaccinatorAddress): any => {
    //   return {
    //     i_type: address.type,
    //     s_country: address.country,
    //     s_state: address.state,
    //     s_city: address.city,
    //     s_postalCode: address.postalCode,
    //     s_houseNumber: address.houseNumber,
    //     s_houseNumberNumeric: address.houseNumberNumeric,
    //     i_streetNameType: address.streetNameType,
    //     s_streetName: address.streetName,
    //     s_additionalLocator: address.additionalLocator,
    //     s_unitId: address.unitId,
    //     s_postBox: address.postBox,
    //     s_precInct: address.precInct,
    //   };
    // };

    return {
      s_hpName: (author as any).s_hpName || author.hpName,
      s_hpGiven: (author as any).s_hpGiven || author.hpGiven,
      s_hpProfession: (author as any).s_hpProfession || author.hpProfession,
      s_hpProfessionOid: (author as any).s_hpProfessionOid || author.hpProfessionOid,
      s_hpSpecialty: (author as any).s_hpSpecialty || author.hpSpecialty && author.hpSpecialty !== '' ? author.hpSpecialty : undefined,
      s_hpInternalId: (author as any).s_hpInternalId || author.hpInternalId,
      i_hpInternalIdType: (author as any).i_hpInternalIdType || Number(author.hpInternalIdType) || undefined,
      // Telecoms: author.Telecoms && author.Telecoms.length > 0 ? author.Telecoms.map(t => _getConvertTelecom(t)) : undefined,
      // Addresses: author.Addresses && author.Addresses.length > 0 ? author.Addresses.map(a => _getConvertAddress(a)) : undefined,
      // Institution: author.Institution && author.Institution.s_id && author.Institution.s_name && author.Institution.s_classCode ? {
      //   s_id: author.Institution.s_id,
      //   s_name: author.Institution.s_name,
      //   s_classCode: author.Institution.s_classCode,
      // } : undefined,
      Institution: {
        s_id: author.Institution.s_id,
        s_name: author.Institution.s_name,
        s_classCode: author.Institution.s_classCode,
      },
    };
  }

  public async validerVaccin(view: ViewContainerRef, sendingParam: DmpHlsendDocumentsParams, vaccin: ValidationVaccination, patientId?: string): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {

      try {
        if (!await this._createConnector(view)) {
          resolve(undefined);
          return;
        }
      } catch (e) {
        if (e instanceof DoRetryError) {
          resolve(await this.validerVaccin(view, sendingParam, vaccin, patientId));
          return;
        } else {
          this._logSendDocError(e, { s_title: 'Note de vaccination' }, patientId);
          reject({ message: 'Une erreur est survenue' });
        }
        return;
      }

      try {
        const session = await this._cpxHandleSrv.getCpxSession(view, await this._getSessionType(view));
        if (!session) {
          resolve(undefined);
          return;
        }
        const author = vaccin.author;
        const performer = vaccin.vaccinator;

        const consumableData = {
          s_name: vaccin.consumable.name,
          s_lotNumber: vaccin.consumable.lotNumber,
          s_cisCode: vaccin.consumable.cisCode,
          s_cisCodeDescription: vaccin.consumable.cisCodeDescription,
          s_cipCode: vaccin.consumable.cipCode || undefined,
          s_cipCodeDescription: vaccin.consumable.cipCodeDescription || undefined,
          s_atcCode: vaccin.consumable.atcCode,
          s_atcCodeDescription: vaccin.consumable.atcCodeDescription,
          s_ucdCode: vaccin.consumable.ucdCode || undefined,  // Pas de précision dans la documentation - Question à poser au support intégrateur
          s_ucdCodeDescription: vaccin.consumable.ucdCodeDescription || undefined,  // Pas de précision dans la documentation - Question à poser au support intégrateur
          s_mvCode: vaccin.consumable.mvCode || undefined,
          s_mvCodeDescription: vaccin.consumable.mvCodeDescription || undefined,
        };

        let date = vaccin.date;
        if (date.length > 8) {
          date = date.slice(0, 8);
        }

        const structuredBody = {
          Sections: [{
            i_type: 30,   // Type de section pour "Note de vaccination" (Voir doc)
            s_title: 'Note de vaccination',   // Section pour "Note de vaccination" (Voir doc)
            Immunizations: [{
              Author: author,
              Performer: performer,
              Consumable: consumableData,
              i_type: vaccin.consumable.type ? Number(vaccin.consumable.type) : undefined,   // Donnée facultative
              i_immunizationRoute: vaccin.consumable.route ? Number(vaccin.consumable.route) : undefined,    // Donnée facultative
              i_approachSite: vaccin.consumable.approachSite ? Number(vaccin.consumable.approachSite) : undefined,   // Donnée facultative
              i_rank: vaccin.consumable.rank ? Number(vaccin.consumable.rank) : undefined,    // Donnée facultative
              i_doseQuantity: vaccin.consumable.doseQty ? Number(vaccin.consumable.doseQty) : undefined,    // Donnée facultative
              s_date: date,
              Comment: vaccin.consumable.comment ? { s_text: vaccin.consumable.comment } : undefined    // Donnée facultative
            }]
          }]
        };

        let visibility = DmpVisibilityEnum['Le document est visible de tous'];
        // Bonjour,
        // le GIE nous confirme que l'ajout d'une note de vaccination ne peut se faire en connexion secrète (lié à l'exigence EX_2.1-2005). La demande à été remontée à la CNAM pour préciser ce point dans la spécification. Nous avons demandé également à ce que le serveur retourne une erreur plus cohérente vis à vis de ce point.
        // Cordialement,
        // Romuald Perrot.
        //
        // if (!!session.confidentialityLevel) {
        //   visibility = DmpVisibilityEnum['Le document n\'est pas visible par le représentant légal du patient'];
        // }
        const documentMeta = {
          s_title: 'Note de vaccination',
          documentId: undefined,
          s_uniqueId: undefined,
          s_category: '87273-9',
          s_classCode: 'Note de Vaccination',
          i_format: 'urn:asip:ci-sis:vac-note:2021',
          s_description: 'Note de Vaccination',
          i_visibility: visibility,
          authors: { auteur: author, vaccinateur: performer },
          dateCreation: date,
          vaccinInformation: structuredBody,
        }
        this._cpxInstance.hl_sendDocument(
          `${sendingParam.s_ins.s_ins}${sendingParam.s_ins.s_ins !== '255069999999934' ? environment.dmpInsSuffix : 'D'}`,
          sendingParam.s_birthPlaceCode,
          undefined,
          'Note de vaccination',
          undefined,
          '87273-9',    // Type "Note de Vaccination"
          visibility,
          'urn:asip:ci-sis:vac-note:2021',      // FormatCode "Note de Vaccination"
          session.PracticeLocations[session.practiceSettingIndice].s_practiceLocationActivity,
          undefined,
          sendingParam.s_submissionSetTitle ? sendingParam.s_submissionSetTitle : '',
          sendingParam.s_submissionSetDescription ? sendingParam.s_submissionSetDescription : '',
          undefined,
          { StructuredBody: structuredBody,  // ICI StructuedBody de la vaccination
            i_retrieveDocumentUuid: 1, },
          async (res) => {
            if (this._cpxHandleSrv.isErrorEndSession(res, SessionTypeEnum.CARTE)) {
              this._logSendDocError(res, structuredBody, patientId);
              resolve(await this.validerVaccin(view, sendingParam, vaccin, patientId));
            } else if (res.error || res.s_status === 'ERROR') {
              const keys = Object.keys(res.error || res);
              const msgArr: Array<string> = [];
              for (const k of keys) {
                msgArr.push(`${k} : ${res.error[k]}`);
              }
              this._logSendDocError(res, documentMeta, patientId);
              reject({ message: msgArr.join('\n') });
            } else {
              this._logSendDocSuccess(res, documentMeta, patientId);
              if (res.s_uniqueId) {
                const session:CpxSessionInterface = await this._cpxHandleSrv.getCpxSession(view, SessionTypeEnum.CARTE);
                const obj:DmpAddMyDocumentsParams = {
                  uuid: '',
                  uniqueId: res.s_uniqueId,
                  patientIns: sendingParam.s_ins.s_ins,
                  rpps: session.dmpConnectSessionInfos.s_internalId,
                  title: 'Note de vaccination',
                  formatCode: 'urn:asip:ci-sis:vac-note:2021',
                  category: '87273-9',
                  visibility: (DmpVisibilityEnum[visibility] as unknown) as DmpVisibilityEnum,
                  createdWithSecretmode: !!session.confidentialityLevel,
                }

                if (vaccin.consumable.comment) {
                  obj.comment = vaccin.consumable.comment
                }

                await this.addMyDocuments(obj);
              }
              resolve(res);
            }
          }
        );
      } catch (e) {
        reject(e);
      }
    });
  }

  public async hl_senddocument(view: ViewContainerRef, sendingParam: DmpHlsendDocumentsParams, document: DmpHlsendDocumentsDocument, documentId?:string, patientId?: string): Promise<any> {
    const isReplacement = !!document.s_uniqueId;

    const _getOidType = (oid: string): string => {
      switch (oid) {
        case 'D':
          return '1.2.250.1.213.1.4.11';
        case 'T':
          return '1.2.250.1.213.1.4.10';
        default:
          return '1.2.250.1.213.1.4.8';
      }
    };

    const userInfosAppToUserInfosDmp = (userInfos: UserInfos): any => {
      return {
        s_hpName: userInfos.name,
        s_hpGiven: userInfos.given,
        s_hpProfession: userInfos.profession,
        s_hpProfessionOid: userInfos.professionOid,
        s_hpSpecialty: userInfos.speciality,
        s_hpInternalId: userInfos.internalId,
        // i_hpInternalIdType: Number(userInfos.internalIdType),
        // i_hpAuthenticationMode: 1,
        Institution: {
          s_id: userInfos.institution.practiceLocationBillingNumber,
          s_name: userInfos.institution.practiceLocationName,
          s_classCode: userInfos.institution.practiceSettingValue,
        }
      };
    };

    return new Promise<any>(async (resolve, reject) => {
      try {
        if (!await this._createConnector(view)) {
          resolve(undefined);
          return;
        }
      } catch (e) {
        this._logSendDocError(e, document, patientId);
        if (e instanceof DoRetryError) {
          resolve(await this.hl_senddocument(view, sendingParam, document, documentId, patientId));
          return;
        } else {
          reject({ message: 'Une erreur est survenue' });
        }
        return;
      }

      try {
        const practiceLocation = await this._getPracticeLocationActivity();
        if (!practiceLocation) {
          resolve(undefined);
          return;
        }

        let visibility: any = DmpVisibilityEnum[document.i_visibility];
        if (await this.getConfidentialityLevel(view)) {
          if ((visibility as any) === DmpVisibilityEnum["Le document est visible de tous"]) {
            visibility = DmpVisibilityEnum["Le document n'est pas visible par le représentant légal du patient"];
          } else if ((visibility as any) === DmpVisibilityEnum["Le document n'est pas visible pour le patient"]) {
            visibility = DmpVisibilityEnum["Le document n'est pas visible par le patient et le représentant légal"];
          } else if ((visibility as any) === DmpVisibilityEnum["Le document n'est pas visible pour les professionnels de santé"]) {
            visibility = DmpVisibilityEnum["Le document n'est pas visible par le représentant légal du patient et le professionnel de santé"];
          }
        }

        if (sendingParam.Identity && !environment.productionDmp) {
          sendingParam.Identity.Ins.s_oid = _getOidType(environment.dmpInsSuffix);
        }
        const performer = sendingParam?.Performer ? userInfosAppToUserInfosDmp(sendingParam.Performer) : undefined;
        const author = sendingParam?.Author ? userInfosAppToUserInfosDmp(sendingParam.Author[0]) : undefined;
        // const authenticator = sendingParam?.Authenticator ? userInfosAppToUserInfosDmp(sendingParam?.Authenticator[0]) : undefined;

        this._cpxInstance.hl_sendDocument(
          `${sendingParam.s_ins.s_ins}${sendingParam.s_ins.s_ins !== '255069999999934' ? environment.dmpInsSuffix : 'D'}`,
          sendingParam.s_birthPlaceCode,
          document.s_contentInBase64,
          document.s_title,
          document.s_description,
          document.s_category,
          visibility,
          document.i_format ? document.i_format : document.s_formatCode,
          practiceLocation.practiceLocationActivity,
          document.s_uniqueId ? document.s_uniqueId : null,
          sendingParam.s_submissionSetTitle ? sendingParam.s_submissionSetTitle : '',
          sendingParam.s_submissionSetDescription ? sendingParam.s_submissionSetDescription : '',
          document.EventCodes,
          /**
           * Le paramètre i_retrieveDocumentUuid permet de récupérer l'uuid
           * du document en sortie de l'appel à hl_sendDocument.
           * Ceci permet d'entretenir la liste des document ajoté au DMP par l'utilisateur.
           */
          {
            i_retrieveDocumentUuid: 1,
            Identity: sendingParam.Identity || undefined,
            Performer: performer ? { Hp: performer } : undefined,
            AdditionalAuthors: author ? [ author ] : undefined,
            i_disablePdfa1Conversion: 1,
            i_getDocumentContent: 1,
            PatientAddresses: document.PatientAddresses ? document.PatientAddresses : undefined,
            /**
             * TODO: Sujet à suivre
             * Le champ legalAuthenticator n'est actuellement pas modifiable avec le connecteur DmpConnect.
             * Ce sujet a été remonté à iCanopée et ils devraient ajouter cette possibilité prochainement.
             */
            // Authenticators: authenticator ? [{ Hp: authenticator }] : undefined, // L'authenticator ou legalAuthenticator n'est pas encore implémenté côté DmpConnect
          },
          async (res) => {
            if (this._cpxHandleSrv.isErrorEndSession(res, SessionTypeEnum.CARTE)) {
              this._logSendDocError(res, document, patientId, isReplacement);
              resolve(await this.hl_senddocument(view, sendingParam, document, documentId, patientId));
            } else if (res.error || res.s_status === 'ERROR') {
              const keys = Object.keys(res.error || res);
              const msgArr: Array<string> = [];
              for (const k of keys) {
                msgArr.push(`${k} : ${res.error[k]}`);
              }
              this._logSendDocError(res, document, patientId, isReplacement);
              reject({ message: msgArr.join('\n') });
            } else {
              this._logSendDocSuccess(res, document, patientId, isReplacement);
              if (res.s_uuid && res.s_uniqueId) {
                const session:CpxSessionInterface = await this._cpxHandleSrv.getCpxSession(view, SessionTypeEnum.CARTE);
                const obj:DmpAddMyDocumentsParams = {
                  uuid: res.s_uuid,
                  uniqueId: res.s_uniqueId,
                  patientIns: sendingParam.s_ins.s_ins,
                  rpps: session.dmpConnectSessionInfos.s_internalId,
                  title: document.s_title,
                  category: document.s_category,
                  visibility: (DmpVisibilityEnum[document.i_visibility] as unknown) as DmpVisibilityEnum,
                  createdWithSecretmode: !!session.confidentialityLevel,
                }

                if (document.s_formatCode) {
                  // If formatCode is not a string convert it to string
                  if(typeof document.s_formatCode !== 'string') {
                    document.s_formatCode = String(document.s_formatCode)
                  }
                  obj.formatCode = document.s_formatCode;
                } else if (document.i_format) {
                  obj.format = document.i_format;
                }

                if (documentId) {
                  obj.documentId = documentId;
                }

                if (document.s_description) {
                  obj.comment = document.s_description;
                }

                let saveSuccess = false;
                for (let i = 0; i < 3; i++) {
                  try {
                    await this.addMyDocuments(obj, document.s_uniqueId);
                    saveSuccess = true;
                    break;
                  } catch (errSave) {
                    console.warn(`[DMP] Échec de la sauvegarde locale de l'uniqueId (tentative ${i + 1}/3)`, errSave);
                    if (i < 2) {
                      // Attendre 1 seconde avant de réessayer
                      await new Promise(r => setTimeout(r, 1000));
                    }
                  }
                }

                if (saveSuccess) {
                  resolve(res);
                } else {
                  reject(new Error("Le document a bien été envoyé au DMP, mais la sauvegarde de l'identifiant a échoué en local après 3 tentatives."));
                }
              } else {
                resolve(res);
              }
            }
          }
        );
      } catch (e) {
        this._logSendDocError(e, document, patientId, isReplacement);
        reject(e);
      }
    });
  }

  private _logSendDocError(err: any, dataSent: any, patientId?: string, isReplacement = false): void {
    this._addLog(buildSendDocErrorLog(err, dataSent, patientId, isReplacement));
  }

  private _logSendDocSuccess(rtd: any, dataSent?: any, patientId?: string, isReplacement = false): void {
    this._addLog(buildSendDocSuccessLog(rtd, dataSent, patientId, isReplacement));
  }

  public async hl_senddocuments(view: ViewContainerRef, sendingParam: DmpHlsendDocumentsParams, documents: DmpHlsendDocumentsDocument[], documentsId?:Array<string>, patientId?: string): Promise<void> {
    const isReplacement = documents.some(d => !!d.s_uniqueId);
    const convertDate = (date: Date): string => {
      const offset = moment(date).utcOffset();

      return `${moment(date).format('YYYYMMDDhhmmss')}${Math.sign(offset) === -1 ? '-' : '+'}${Math.floor(Math.abs(offset / 60)).toString().padStart(2, '0')}${(Math.abs(offset) % 60).toString().padStart(2, '0')}`;
    };

    return new Promise<void>(async (resolve, reject) => {
      try {
        if (!await this._createConnector(view)) {
          resolve(undefined);
          return;
        }
      } catch (e) {
        if (e instanceof DoRetryError) {
          resolve(await this.hl_senddocuments(view, sendingParam, documents, documentsId));
          return;
        } else {
          reject({ message: 'Une erreur est survenue' });
        }
        return;
      }

      try {
        const tmpDocs: Array<DmpHlsendDocumentsDocument> = [];

        for (const d of documents) {
          (d as any).i_visibility = DmpVisibilityEnum[d.i_visibility];
          d.s_formatCode = d.i_format ? undefined : d.s_formatCode;
          (d as any).s_creationDate = d.s_creationDate ? convertDate(d.s_creationDate) : undefined;
          (d as any).s_serviceStopDate = d.s_serviceStopDate ? convertDate(d.s_serviceStopDate) : undefined;
          (d as any).s_serviceStartDate = d.s_serviceStartDate ? convertDate(d.s_serviceStartDate) : undefined;
          tmpDocs.push(d);
        }

        const practiceLocation = await this._getPracticeLocationActivity();
        if (!practiceLocation) {
          resolve(undefined);
          return;
        }

        this._cpxInstance.hl_sendDocuments(
          `${sendingParam.s_ins.s_ins}${environment.dmpInsSuffix}`,
          practiceLocation.practiceLocationActivity,
          sendingParam.s_submissionSetTitle ? sendingParam.s_submissionSetTitle : '',
          sendingParam.s_submissionSetDescription ? sendingParam.s_submissionSetDescription : '',
          null,
          tmpDocs,
          { i_retrieveDocumentUuid: 1 },
          async (res) => {
            if (this._cpxHandleSrv.isErrorEndSession(res, SessionTypeEnum.CARTE)) {
              resolve(await this.hl_senddocuments(view, sendingParam, documents, documentsId, patientId));
            } else if (res.error || res.s_status === 'ERROR') {
              const keys = Object.keys(res.error || res);
              const msgArr: Array<string> = [];
              for (const k of keys) {
                msgArr.push(`${k} ;: ${res.error[k]}`);
              }
              this._logSendDocError(res, documents, patientId, isReplacement);
              reject({ message: msgArr.join('\n') });
            } else {
              this._logSendDocSuccess(res, documents, patientId, isReplacement);
              resolve(res);
              await this._addSentDocumentsToMyDocuments(view, sendingParam, documents, res, documentsId);
            }
          }
        );
      } catch (e) {
        this._logSendDocError(e, documents, patientId, isReplacement);
        reject(e);
      }
    });
  }

  /**
   * Enregistre dans documents-dmp chaque document envoyé par hl_sendDocuments, sur le modèle de hl_senddocument.
   * Un échec d'enregistrement n'est pas remonté : le DMP a bien reçu les documents.
   */
  private async _addSentDocumentsToMyDocuments(
    view: ViewContainerRef,
    sendingParam: DmpHlsendDocumentsParams,
    documents: DmpHlsendDocumentsDocument[],
    res: any,
    documentsId?: Array<string>
  ): Promise<void> {
    let session: CpxSessionInterface;
    for (let index = 0; index < documents.length; index++) {
      const document = documents[index];
      // Réponse attendue : UniqueIds / Uuids (même ordre que les documents), ou Documents[].s_uniqueId / s_uuid
      const uniqueId: string = res?.UniqueIds?.[index] || res?.Documents?.[index]?.s_uniqueId;
      const uuid: string = res?.Uuids?.[index] || res?.Documents?.[index]?.s_uuid;
      if (!uniqueId || !uuid) {
        continue;
      }

      try {
        session = session || await this._cpxHandleSrv.getCpxSession(view, SessionTypeEnum.CARTE);
        // i_visibility a déjà été converti en nombre avant l'envoi
        const visibility = typeof document.i_visibility === 'number'
          ? document.i_visibility
          : (DmpVisibilityEnum[document.i_visibility as any] as unknown) as DmpVisibilityEnum;
        const obj: DmpAddMyDocumentsParams = {
          uuid,
          uniqueId,
          patientIns: sendingParam.s_ins.s_ins,
          rpps: session.dmpConnectSessionInfos.s_internalId,
          title: document.s_title,
          category: document.s_category,
          visibility,
          createdWithSecretmode: !!session.confidentialityLevel,
        };

        if (document.s_formatCode) {
          obj.formatCode = String(document.s_formatCode);
        } else if (document.i_format) {
          obj.format = document.i_format;
        }

        if (documentsId?.[index]) {
          obj.documentId = documentsId[index];
        }

        if (document.s_description) {
          obj.comment = document.s_description;
        }

        await this.addMyDocuments(obj, document.s_uniqueId);
      } catch (e) {
        console.error(e);
      }
    }
  }

  public async reinitializeConnector(view: ViewContainerRef, ): Promise<void> {
    const session = await this._getCpxSession(view);
    if (!session) {
      return;
    }
    await this._createConnector(view);
  }

  private async _createConnector(view: ViewContainerRef): Promise<boolean>{
    return new Promise<boolean>(async (resolve, reject) => {
      if (!await this._getCpxSession(view)) {
        resolve(false);
        return;
      }

      try {
        if (!this.resourceId || this.resourceId === '') {
          throw {
            message: 'La ressource n\'est pas renseignée'
          };
        }

        // On récupère et on vérifie la validité des paramètres
        let practiceSettingValue: string;
        const params = await this._resourceSrv.getResourceSettings(this.resourceId, 'profil');
        if (params) {
          for (const param of params) {
            if (param.settingKey === practiceSettingKey) {
              practiceSettingValue = param.settingValue;
            }
          }
        } else {
          throw {
            message: 'Les paramètres de DMP sont manquants'
          };
        }

        if (!practiceSettingValue || practiceSettingValue === '') {
          throw {
            message: 'Le cadre d\'exercice n\'est pas renseigné dans les paramètres'
          };
        }

        const cpxInstance = await this._getCpxInstance(view);
        if (!cpxInstance) {
            return;
        }

        const sessionType = await this._getSessionType(view);
        const cpxSession = await this._cpxHandleSrv.getCpxSession(view, sessionType);
        if (cpxSession.isSessionOpen && (cpxSession as CpxSessionInterface).isDmpConnectorCreated) {
          resolve(true);
          return;
        }

        if (sessionType === SessionTypeEnum.CERT_DMP) {

          let hpParam : {} = {}
          let practiceLocation: {} = {};
          let professionSettingParam: string;
          let specialiteSettingParam: string;
          let nomSettingParam: string;
          let prenomSettingParam: string;
          let nomStructureSettingParam: string;
          let typeStructureSettingParam: string;
          let contentTypeCodeSettingParam: string;
          let professionSettingOid: string;

          let professionsRef=[];
          const professionSettingsArrTmp = await this._refSrv.findRefListTableHypermed("RefSubjectRoleDMP");
          for (const ps of professionSettingsArrTmp) {
            professionsRef.push({
              id: ps.id.split('++')[0],
              oid : ps.sublibelle,
              libelle: ps.libelle
            });
          }

          const professionSetting = params.find(p => p.settingKey === professionSettingKey);
          if (professionSetting && professionSetting.settingValue !== '') {
            professionSettingParam = professionSetting.settingValue;
            professionSettingOid = professionsRef.find(p => p.id === professionSettingParam).oid;
          } else {
            throw {
              message: 'La profession n\'est pas renseignée dans les paramètres'
            };
          }

          const specialiteSetting = params.find(p => p.settingKey === specialiteSettingKey);
          if (specialiteSetting && specialiteSetting.settingValue !== '') {
            specialiteSettingParam = specialiteSetting.settingValue;
          } else {
            throw {
              message: 'La spécialité n\'est pas renseignée dans les paramètres'
            };
          }
          const nomSetting = params.find(p => p.settingKey === nomSettingKey);
          if (nomSetting && nomSetting.settingValue !== '') {
            nomSettingParam = nomSetting.settingValue;
          } else {
            throw {
              message: 'Le nom n\'est pas renseignée dans les paramètres'
            };
          }
          const prenomSetting = params.find(p => p.settingKey === prenomSettingKey);
          if (prenomSetting && prenomSetting.settingValue !== '') {
            prenomSettingParam = this._strUtilsSrv.uppercaseFirstCharString(prenomSetting.settingValue);
          } else {
            throw {
              message: 'Le prénom n\'est pas renseignée dans les paramètres'
            };
          }

          const nomStructureSetting = params.find(p => p.settingKey === nomStructureSettingKey);
          if (nomStructureSetting && nomStructureSetting.settingValue !== '') {
            nomStructureSettingParam = nomStructureSetting.settingValue;
          } else {
            throw {
              message: 'Le nom de structure n\'est pas renseignée dans les paramètres'
            };
          }
          const typeStructureSetting = params.find(p => p.settingKey === typeStructureSettingKey);
          if (typeStructureSetting && typeStructureSetting.settingValue !== '') {
            typeStructureSettingParam = typeStructureSetting.settingValue;
          } else {
            throw {
              message: 'Le type de structure n\'est pas renseignée dans les paramètres'
            };
          }
          const contentTypeCodeSetting = params.find(p => p.settingKey === contentTypeCodeSettingKey);
          if (contentTypeCodeSetting && contentTypeCodeSetting.settingValue !== '') {
            contentTypeCodeSettingParam = contentTypeCodeSetting.settingValue;
          } else {
            throw {
              message: 'Le type d\'activité structure n\'est pas renseignée dans les paramètres'
            };
          }

          hpParam = {
            s_hpName: nomSettingParam,
            s_hpGiven: prenomSettingParam,
            s_hpProfession: professionSettingParam,
            s_hpProfessionOid: professionSettingOid,
            s_hpSpeciality: specialiteSettingParam,
            s_hpInternalId: this.resourceId,
            i_hpAuthenticationMode: 9
          }

          practiceLocation = {
            s_practiceLocationName: nomStructureSettingParam,
            s_practiceLocationActivitySector: typeStructureSettingParam,
            s_practiceLocationPracticeSettings: practiceSettingValue,
          }

          hpParam = {
            s_hpName: nomSettingParam,
            s_hpGiven: prenomSettingParam,
            s_hpProfession: professionSettingParam,
            s_hpProfessionOid: professionSettingOid,
            s_hpSpeciality: specialiteSettingParam,
            s_hpInternalId: this.resourceId,
            i_hpAuthenticationMode: 9
          }

          practiceLocation = {
            s_practiceLocationName: nomStructureSettingParam,
            s_practiceLocationActivitySector: typeStructureSettingParam,
            s_practiceLocationPracticeSettings: practiceSettingValue,
          }

          await this.hl_createEsDmpConnector(
            cpxInstance,
            environment.dmpServerUrl,
            60,
            hpParam,
            practiceLocation,
            {},                // Paramètres optionnels
            (response) => {
                if (response.s_status === 'OK') {
                    cpxSession.isSessionOpen = true;
                    resolve(true);
                } else {
                    if (response.error.i_apiErrorCode === 3 && response.error.i_apiErrorType === 6000) {
                        reject(new DoRetryError());
                    } else {
                        reject(response.error);
                    }
                }
            }
          );
        } else {
          const practiceLocation  = await this._getPracticeLocationActivity();
          if (!practiceLocation || !practiceLocation.pinCode || (!practiceLocation.practiceSettingIndice && practiceLocation.practiceSettingIndice !== 0)) {
            throw {
              message: 'Une connexion par carte CPx est nécessaire'
            };
          }

          let practiceLocationFormation = undefined;
          let hp = undefined;
          const session = await this._cpxHandleSrv.getCpxSession(view, SessionTypeEnum.CARTE);
          if (session && session.cpxType === CpxTypeEnum.CPF) {
            practiceLocationFormation = session.PracticeLocations[session.practiceSettingIndice];
            hp = session.Hp;
          }

          cpxInstance.hl_createDmpConnector(
            practiceLocation.pinCode,
            environment.dmpServerUrl,
            60,
            practiceSettingValue,
            practiceLocation.practiceSettingIndice,
            {
              PracticeLocation: practiceLocationFormation || undefined,
              Hp: hp || undefined
            },                // Paramètres optionnels
            (res) => {
              if (res.error && res.error.i_apiErrorCode === 3 && res.error.i_apiErrorType === 6000) {
                  reject(new DoRetryError());
              } else if (res.s_status === 'ERROR') {
                reject(res);
              } else if (res.error) {
                reject({ message: res.error.s_apiErrorDmpErrorDetails });
              } else {
                cpxSession.isSessionOpen = true;
                this._cpxHandleSrv.setDmpConnectorIsCreated(SessionTypeEnum.CARTE, TypeConnecteurEnum.DMPConnect, true);
                resolve(true);
              }
            }
          );
        }
      } catch (e) {
        reject(e);
      }
    });
  }

  async hl_createEsDmpConnector(cpxInstance:any,
    dmpServerUrl: string,
    transactionsTimeoutInSeconds: number,
    hpParam: any,
    practiceLocation: any,
    optionalParameters : {}, resultCallback : (response: any) => void) {


    // Récupération des infos utilisateurs

    // Récupération des infos PracticeLocation


    var serverUrl = "";
    // Empty string => qualification server.
    if( dmpServerUrl === "" )
        serverUrl = "devh";
    else
        serverUrl = dmpServerUrl;

    var command = {
        "s_commandName"               : "hl_createEsDmpConnector",
        "s_dmpUrl"                   : serverUrl,
        "i_transactionsTimeout"       : transactionsTimeoutInSeconds,
        "i_getConnectionHandle"       : 1,
        "PracticeLocation"            : practiceLocation,
        "Hp"                          : hpParam,
        "s_sessionId"                 : cpxInstance.getSessionId()
    };

    // Merge the HTTP proxy parameters and/or the NTP proxy parameters set in optionalParameters.
    if( optionalParameters )
    {
        for( var p in optionalParameters )
        {
            command[ p ] = optionalParameters[ p ];
        }
    }

    // Get connection handle
    return cpxInstance.sendCommand( command, 20, resultCallback );
  }

  public async getDmpParameters(view: ViewContainerRef): Promise<DmpParameters> {
    return new Promise<DmpParameters>(async (resolve, reject) => {
      try {
        if (!await this._createConnector(view)) {
          resolve(undefined);
          return;
        }
      } catch (e) {
        if (e instanceof DoRetryError) {
          resolve(await this.getDmpParameters(view));
          return;
        } else {
          reject({ message: 'Une erreur est survenue' });
        }
        return;
      }

      try {
        this._cpxInstance.hl_getDmpParameters(
          async (res) => {
            if (this._cpxHandleSrv.isErrorEndSession(res, SessionTypeEnum.CARTE)) {
              resolve(await this.getDmpParameters(view));
            } else if (res.error || res.s_status === 'ERROR') {
              const keys = Object.keys(res.error || res);
              const msgArr: Array<string> = [];
              for (const k of keys) {
                msgArr.push(`${k} : ${res.error[k]}`);
              }
              reject({ message: msgArr.join('\n') });
            } else {
              resolve({
                cumulMasquePsPatient: Boolean(res.i_cumulMasquePsPatient),
                hrMaxSearchPeriod: res.i_hrMaxSearchPeriod,
                majorityAge: res.i_majorityAge,
                minorFunctionManagement: Boolean(res.i_minorFunctionManagement),
              });
            }
          }
        );
      } catch (e) {
        reject(e);
      }
    });
  }

  public async getMajorityAge(view: ViewContainerRef): Promise<number> {
    return new Promise<number>(async (resolve, reject) => {
      try {
        if (!await this._createConnector(view)) {
          resolve(undefined);
          return;
        }
      } catch (e) {
        if (e instanceof DoRetryError) {
          resolve(await this.getMajorityAge(view));
          return;
        } else {
          reject({ message: 'Une erreur est survenue' });
        }
        return;
      }

      try {
        this._cpxInstance.hl_getMajorityAge(
          async (res) => {
            if (this._cpxHandleSrv.isErrorEndSession(res, SessionTypeEnum.CARTE)) {
              resolve(await this.getMajorityAge(view));
            } else if (res.error || res.s_status === 'ERROR') {
              const keys = Object.keys(res.error || res);
              const msgArr: Array<string> = [];
              for (const k of keys) {
                msgArr.push(`${k} : ${res.error[k]}`);
              }
              reject({ message: msgArr.join('\n') });
            } else {
              resolve(res.i_majorityAge);
            }
          }
        );
      } catch (e) {
        reject(e);
      }
    });
  }

  public async setConfidentialityLevel(view: ViewContainerRef, enable: boolean): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      try {
        if (!await this._createConnector(view)) {
          resolve(undefined);
          return;
        }
      } catch (e) {
        if (e instanceof DoRetryError) {
          resolve(await this.setConfidentialityLevel(view, enable));
          return;
        } else {
          if (typeof e === 'string') {
            reject({ message: e });
          } else if (typeof e === 'object' && e.message) {
            reject(e);
          } else {
            reject({ message: 'Une erreur est survenue' });
          }
        }
        return;
      }

      try {
        this._cpxInstance.hl_setConfidentialityLevel(
          Number(enable),
          async (res) => {
            if (this._cpxHandleSrv.isErrorEndSession(res, SessionTypeEnum.CARTE)) {
              resolve(await this.setConfidentialityLevel(view, enable));
            } else if (res.error || res.s_status === 'ERROR') {
              const keys = Object.keys(res.error || res);
              const msgArr: Array<string> = [];
              for (const k of keys) {
                msgArr.push(`${k} : ${res.error[k]}`);
              }
              reject({ message: msgArr.join('\n') });
            } else {
              resolve();
              const session = await  this._cpxHandleSrv.getCpxSession(view, await this._getSessionType(view));
              if (session) {
                session.confidentialityLevel = enable;
              }
            }
          }
        );
      } catch (e) {
        reject(e);
      }
    });
  }

  public async getConfidentialityLevel(view: ViewContainerRef): Promise<boolean> {
    const session = await  this._cpxHandleSrv.getCpxSession(view, await this._getSessionType(view));
    return !!session?.confidentialityLevel;
  }

  private async _getCpxInstance(view: ViewContainerRef): Promise<any> {
    return new Promise<any>(async (resolve, reject) => {
      try {
          const isEs = await this._cpxHandleSrv.isESConnexionIndirect(SessionTypeEnum.CERT_DMP);
          const typeSession = isEs ? SessionTypeEnum.CERT_DMP : SessionTypeEnum.CARTE;
          if (this.typeSession !== typeSession) {
              this._cpxInstance = undefined;
              this.typeSession = typeSession;
          }

          this._cpxInstance = await this._cpxHandleSrv.getInstance(view, this.typeSession);

          resolve(this._cpxInstance);
      } catch (e) {
        reject(e);
      }
    });
  }

  public async sendRawPDFDocument(view: ViewContainerRef, documentb64: string, patientId: string, typeDocument:TypeDocumentDMP, titreDocument:string, documentId?:string): Promise<any> {
    // On vérifie que le patient ait un statut d'identité qualifié
    // On passe la confidentialité à false pour réinitialiser le confidentiality-code des appels DMP
    await this.setConfidentialityLevel(view, false);

    const patient = await this._getPatientIfQualifie(patientId);
    // patient.dateNaissance = moment('2015-03-04', 'YYYY-MM-DD').format('YYYY-MM-DD');
    const dmpParams = await this.getDmpParameters(view);
    if (patient && patient.dateNaissance && dmpParams.minorFunctionManagement && dmpParams.majorityAge && moment(new Date()).subtract(dmpParams.majorityAge, 'year').isBefore(moment(patient.dateNaissance, 'YYYY-MM-DD'))) {
      await this._askConnexionSecrete(view);
    }
    if (!patient) {
      throw Error('Le patient n\'est pas qualifié, impossible d\'envoyer le document')
    } else {
      if (typeDocument && typeDocument.meta.s_code) {
        // On vérifie le statut du DMP patient
        if (!await this._getDmpSession(view)) {
          this._modal.openAlert(view, 'Erreur', 'Impossible de récupérer la session DMP');
          return;
        }
        const patientDmp = await this.hl_getdirectauthentificationdmpstatus(view, `${patient.ins}${patient.insKey}${environment.dmpInsSuffix as 'D' | 'T' | 'N'}`);
        if (patientDmp && patientDmp.ExistingTestAnswer.i_dmpStatus === DmpStatusEnum['DMP existant']
          && (patientDmp.ExistingTestAnswer.i_userAuthorization === DmpUserAuthorizationEnum.AuthorizationExist)
        ) {
          // Pour envoyer dans le DMP automatiquement nous devons demander la visibilité du document
          // const modalAlert = this._modal.openAlert(this._view, "Envoi automatique au DMP",
          //   "Ce type de document doit être envoyé automatiquement via le DMP veuillez confirmer la visibilité du document");
          // await new Promise<void>((r, _) => {
          //   const sub = modalAlert.instance.closeEmitter.subscribe(async (res) => {
          //     sub.unsubscribe();
          //     r();
          //   });
          // });

          const confidentialityLevel = await this.getConfidentialityLevel(view);
          for (const v of this.documentVisibilite) {
            if (confidentialityLevel && (
              v.id === DmpVisibilityEnum["Le document est visible de tous"] as any
              || v.id === DmpVisibilityEnum["Le document n'est pas visible pour le patient"] as any
              || v.id === DmpVisibilityEnum["Le document n'est pas visible pour les professionnels de santé"] as any
            )) {
              v.disabled = true;
            }
          }

          const formTemplate: FormTemplate = {
            inputs: [
              {
                variable: 'visibilite',
                type: 'ngSelect',
                id: 'visibiliteId',
                label: 'Visibilité',
                placeholder: 'Visibilité',
                required: true,
                selectOptions: this.documentVisibilite
              },
            ],
            validators: []
          };

          const modaleVisibilite = this._modal.openModalAddEdit('Visibilité du document', view, formTemplate, true);
          modaleVisibilite.instance.dismissable = false;
          const dmpVisibility = await new Promise<any>((r, _) => {
            // Close emiter pour toutes les modales :cry: TODO
            const sub = this._modal.closeEmitter.subscribe(async (res) => {
              sub.unsubscribe();
              if (res && res.loadingModal) {
                (res.loadingModal as ComponentRef<LoadingModalFragment>).destroy();
              }
              if (res && res.addEditFragment) {
                (res.addEditFragment as ComponentRef<AddEditFragment>).destroy();
              }
              if (res?.object?.visibilite) {
                r(res.object.visibilite);
              } else {
                r(undefined);
              }
            });
          });

          if (dmpVisibility) {
            // On génère la base 64 du courrier
            const cleanBase64 = documentb64.split('base64,')[1];

            // On peut désormais envoyer le document sur le DMP
            const result = await this.hl_senddocument(
              view,
              {
                s_healthcareSetting: '',
                s_ins: {
                  s_ins: `${patient.ins}${patient.insKey}`,
                  s_insType: environment.dmpInsSuffix as 'D' | 'T' | 'N'
                },
                s_birthPlaceCode: patient.cpNaissance,
              }, {
                EventCodes: undefined,
                i_format: DmpFormatEnum['Document au format PDF'],
                i_visibility: (DmpVisibilityEnum[dmpVisibility] as unknown) as DmpVisibilityEnum,
                s_category: typeDocument.meta.s_code as DmpHlGetInteropCodesEnum,
                s_contentInBase64: cleanBase64,
                s_creationDate: moment().toDate(),
                s_description: '',
                s_formatCode: undefined,
                s_serviceStartDate: undefined,
                s_serviceStopDate: undefined,
                s_title: titreDocument + '.pdf'
              }, documentId
            );

            await new Promise<void>((resolve) => {
              const confirmModlal = this._modal.openAlert(
                view, 'Document envoyé', 'Le document a bien été envoyé sur le DMP du patient.'
              );
              const confirmModlalSub = confirmModlal.instance.closeEmitter.subscribe(() => {
                confirmModlalSub.unsubscribe();
                resolve();
              });
            });

            return result;
          } else {
            throw Error('Erreur lors de la récupération de la visibilité du document');
          }
        } else {
          throw Error('Le patient n\'a pas de DMP (ou il est fermé) ou une erreur est survenue lors de la récupération du statut de celui-ci');
        }
      }
    }
  }

  private async _askConnexionSecrete(view: ViewContainerRef): Promise<void> {
    return new Promise<void>((async (resolve, reject) => {
      try {
        const modal = this._modal.openModalConfirmation(
          view,
          'Connexion secrète',
          `Le patient est mineur, voulez-vous accéder à son DMP en mode connexion secrète ?\n\nLe mode connexion secrète ne laisse pas de trace d'accès visible pour les représentants légaux et permet ainsi de protéger le secret des mineurs.`
        );
        const sub = modal.instance.closeEmitter.subscribe(async (res) => {
          if (res) {
            await this.setConfidentialityLevel(view, res);
          }
          resolve();
          sub.unsubscribe();
        });
      } catch (e) {
        reject(e);
      }
    }));
  };

  private async _getPatientIfQualifie(idPatient: string): Promise<FichePatient | undefined> {
    return new Promise<FichePatient | undefined>(async (resolve, reject) => {
      try {
        const patient = await this._patientSrv.findOnePatientFiche(idPatient);
        if (patient && patient.identiteStatutId === '95a6081f-5260-44b8-9661-e4795e1cfcaf'
          && patient.ins && patient.ins !== '' && patient.insKey && patient.insKey !== '') {
          resolve(patient);
        } else {
          resolve(undefined);
        }
      } catch (e) {
        console.error(e);
        reject(e);
      }
    });
  }

  private async _getDmpSession(view: ViewContainerRef): Promise<CpxSessionInterface | undefined> {
    const useCert = await this._cpxHandleSrv.isESConnexionIndirect(SessionTypeEnum.CERT_DMP);
    const typeSession = useCert ? SessionTypeEnum.CERT_DMP : SessionTypeEnum.CARTE;
    let rtd: CpxSessionInterface | undefined = undefined;
    if (this._cpxHandleSrv.isSessionOpen(typeSession)) {
      rtd = await this._cpxHandleSrv.getCpxSession(view, typeSession);
    }

    if (rtd && rtd.practiceSettingIndice !== undefined && rtd.practiceSettingIndice !== null) {
      return rtd;
    } else if (rtd && (rtd.practiceSettingIndice === undefined || rtd.practiceSettingIndice === null)) {
      await this._cpxHandleSrv.closeSession(SessionTypeEnum.CARTE);
      return await this._getDmpSession(view);
    } else {
      return undefined;
    }
  }

  private async initListTypeDocument(): Promise<void> {
    const typeDocumentArrTmp = await this._ref.findRefListTableHypermed(ReferentielEnum.typecode_dmp);
    for (const typeD of typeDocumentArrTmp) {
      this.dmpTypeDocument.push({
        id: typeD.id,
        libelle: typeD.libelle,
        meta: {
          s_code: typeD.id.split('++')[0],
          s_displayName: typeD.libelle,
          s_codeSystem: typeD.sublibelle,
        }
      })
    }
    this.dmpTypeDocument.sort((a, b) => {
      return a.libelle.localeCompare(b.libelle);
    });
  }

  private async _addLog(obj: LogObject): Promise<void> {
    try {
      if (!this._logCallSrv) {
        this._logCallSrv = this._logSrv.getConfiguration(DomainEnum.Dmp);
      }

      this._logCallSrv.addLog(obj);
    } catch (e) {
      console.error(e);
    }
  }
}
